// removed by extract-text-webpack-plugin
module.exports = {"component":"LVVGB4n2B7tIAPTz-PUZi","lar_box":"_1InsAlNH8rtiWnAh-cIU7-","lar_atcoi1":"_2ckiZ3kYjgWWmg5IYBhNlV","img_a2":"cDFUrpx3SLGjz5D-zUQqo","img_a1":"LhADH0eOvAFa3RtZTm3o0","lie_a1":"_2hkrm2QsV-mb6wSHTlzCGi","all_table":"_3BLcvHRQlqjeXY1DCrN3eo","pt":"_331Gv40YsPW92k_Cuj4dmf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopProductDetails/ExperienceShopProductDetails.scss
 ** module id = 1063
 ** module chunks = 0
 **/